import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { AthleteRow } from "../../providers/athletes-provider";
import { MatIcon } from "@angular/material/icon";
import { DefaultPipe } from "../../../common/pipes/default";
import { TranslateModule } from "@ngx-translate/core";
import { MatButton } from "@angular/material/button";
import { NgIf } from "@angular/common";

@Component({
  selector: 'popup-contact-athlete-form',
  providers: [],
  styleUrls: ['./popup-contact.scss'],
  standalone: true,
  imports: [
    MatIcon,
    MatDialogTitle,
    DefaultPipe,
    TranslateModule,
    MatButton,
    MatDialogClose,
    NgIf,
  ],
  templateUrl: './popup-contact.html'
})
export class PopupContactAthleteFormComponent {
    public formTitle = '';
    public athlete: AthleteRow = {} as AthleteRow;

    constructor(
        public dialog: MatDialogRef<PopupContactAthleteFormComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {
        if (this._data.athleteRow) {
            this.athlete = this._data.athleteRow;
        }

        this.formTitle = this._data.formTitle;
    }
}
